export enum RsvpRenderState {
    ShowPlaceholder,
    PartialRender,
    CompleteRender,
}
